<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados da Composição</mat-panel-title>
            </mat-expansion-panel-header>

            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                
                <mat-form-field fxFlex="50%" fxFlexOffset="20px">
                    <mat-label>Cargo:</mat-label>
                    <mat-select [(ngModel)]="composicaoRhPrograma.cargo.id" name="cargo" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let m of cargos" [value]="m.id">
                            {{m.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="cargos?.length === 0" align="start">Nenhum cargo cadastrado</mat-hint>
                </mat-form-field>

                <mat-form-field fxFlex="50%" fxFlexOffset="20px">
                    <mat-label>Tipo de Contratação:</mat-label>
                    <mat-select [(ngModel)]="composicaoRhPrograma.tiposContratacoes.id" name="tipoContratacao" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let m of listaTiposContratacoes" [value]="m.id">
                            {{m.codigoTipoContratacao}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="listaTiposContratacoes?.length === 0" align="start">Nenhum tipo de contratação cadastrado</mat-hint>
                </mat-form-field>

                <mat-form-field fxFlex= "46%" fxFlexOffset="20px" >
                    <input #descricao matInput maxlength="200"  type="number" name="qtd" placeholder="Quantidade:" [(ngModel)]="composicaoRhPrograma.qtd" required >
               </mat-form-field>

            </div>


            
            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar"   mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>
              
                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" [disabled]=formulario.invalid fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Composições ( {{listaComposicaoRhPrograma?.length}} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="cargo">
                    <th mat-header-cell *matHeaderCellDef> Cargo </th>
                    <td mat-cell *matCellDef="let element"> {{element.cargo.nome}} </td>
                </ng-container>

                <ng-container matColumnDef="tipoContratacao">
                    <th mat-header-cell *matHeaderCellDef> Tipo Contratação</th>
                    <td mat-cell *matCellDef="let element"> {{element.tiposContratacoes.descricaoTipoContratacao}} </td>
                </ng-container>

                <ng-container matColumnDef="qtd">
                    <th mat-header-cell *matHeaderCellDef> qtd</th>
                    <td mat-cell *matCellDef="let element"> {{element.qtd}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizarComposicao(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova composição" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</form>
